import { defineStore } from 'pinia'

export const readLocalstorage = (key, defaultValue) => {
  const readValue = localStorage.getItem(key)

  try {
    if (readValue) {
      return JSON.parse(readValue)
    } else {
      return defaultValue
    }
  } catch (error) {
    return defaultValue
  }
}

export const globalData = defineStore({
  id: 'globalData',
  state: () => ({
    menuIndex: localStorage.getItem('menuIndex') || '0-0',
    selectedNav: localStorage.getItem('selectedNav') || 'design',
    userInfo: readLocalstorage('userInfo', {}),
    loadingInstance: null,
    token: localStorage.getItem('token'),
    loginVisible: false,
    baseConfig: readLocalstorage('baseConfig', [])
  }),
  getters: {
    getLogoUrl(state){
      if(state.baseConfig.length == 0) {
        return ''
      }
      const logoUrl = state.baseConfig.filter(
        (item) => item.paramCode === 'logo_url'
      )[0].paramValue;
      return logoUrl
    },
    getParamFromBaseConfig: (state) => (paramCode) => {
      if(state.baseConfig.length == 0) {
        return ''
      }
      return state.baseConfig.filter(
        (item) => item.paramCode === paramCode
      )[0];
    },
  },
  actions: {
    setUserInfo(userInfo) {
      localStorage.userInfo = JSON.stringify(userInfo)
      this.userInfo = userInfo;
    },
    setMenuIndex(index) {
      localStorage.setItem('menuIndex', index);
      this.menuIndex = index;
    },
    setSelectedNav(nav) {
      localStorage.setItem('selectedNav', nav);
      this.selectedNav = nav;
    },
    showLoading(index = {}) {
      // ElLoading.service返回的是同一个实例
      const options = Object.assign({
        text: '加载中',
        background: 'transparent',
      }, index);
      this.loadingInstance = ElLoading.service(options);
    },
    hideLoading() {
      if (this.loadingInstance) {
        this.loadingInstance.close()
      }
    },
    setToken(token) {
      localStorage.token = token;
      this.token = token
    },
    setLoginVisible(visible) {
      this.loginVisible = visible;
    },
    setBaseConfig(baseConfig) {
      localStorage.baseConfig = JSON.stringify(baseConfig)
      this.baseConfig = baseConfig;
    },
  },
})